import React from 'react';
import PageHeader from '../../components/layout/PageHeader';
import ParentsCard from '../../components/cards/ParentsCard';
import parentsResources from '../../cms/parents.json';
import pageContent from '../../cms/page-content.json';
import RichText from '../../components/ui/RichText';
import '../../css/parents/StayInformed.css';

const StayInformed = () => {
  const stayInformedResources = parentsResources.filter(resource => 
    resource.icon === 'facebook' || resource.icon === 'network'
  );

  return (
    <>
      <PageHeader 
        title={pageContent.stayInformedTitle} 
        subtitle={pageContent.stayInformedSubtitle}
      />
      
      <div className="stay-informed-container">
        <section className="stay-informed-intro">
          <div className="intro-content">
            <h2>{pageContent.stayInformedHeading}</h2>
            <RichText value={pageContent.stayInformedBody} />
          </div>
        </section>

        <section className="stay-informed-resources">
          <h2>{pageContent.stayInformedResourcesHeading}</h2>
          <div className="resources-grid">
            {stayInformedResources.map((resource) => (
              <ParentsCard key={resource.id} resource={resource} />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default StayInformed;